import { useDocumentScrollProgress } from "../../hooks/useDocumentScrollProgress";
import "../../styles/scroll_progress.css";

export default function ScrollProgress() {
  const ratio = useDocumentScrollProgress();

  return (
    <div
      className="scroll-progress"
      style={{ transform: `scaleX(${ratio})` }}
      aria-hidden="true"
    />
  );
}
